export default __webpack_public_path__ + "static/media/adminstration.e7214866.svg";